"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HotelReportPageActions;
(function (HotelReportPageActions) {
    HotelReportPageActions["DataLoaded"] = "DataLoaded";
})(HotelReportPageActions || (HotelReportPageActions = {}));
exports.default = HotelReportPageActions;
